module.exports = __webpack_public_path__ + "assets/img/3.31f48e63.jpg";